/**
 * Parade-TD Cohesive Custom UI SVG & Asset Icon Library
 * centralizes all icons, reusing existing SVG/PNG visual assets,
 * and mapping key tokens to HTML strings with layouts.
 */
(function() {
  const GameIcons = {
    // Reusable inline SVGs matching original top-bar layouts
    _permitsSvg: (size, style) => `
      <svg class="game-icon stat-icon icon-permits" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; ${style}">
        <rect x="4" y="3" width="12" height="17" rx="1.5" fill="#F3E9D2" stroke="#C9B486" stroke-width="1.2"/>
        <line x1="6.5" y1="7" x2="13" y2="7" stroke="#B9A783" stroke-width="1.2" stroke-linecap="round"/>
        <line x1="6.5" y1="10" x2="13.5" y2="10" stroke="#C9B486" stroke-width="1" stroke-linecap="round"/>
        <line x1="6.5" y1="12.5" x2="11" y2="12.5" stroke="#C9B486" stroke-width="1" stroke-linecap="round"/>
        <g transform="translate(15.5,15)">
          <polygon points="-2.2,1 -3.6,7.6 0,4.9" fill="#C0392B"/>
          <polygon points="2.2,1 3.6,7.6 0,4.9" fill="#E4572E"/>
          <circle cx="0" cy="0" r="5.6" fill="#C77F14"/>
          <circle cx="0" cy="0" r="5" fill="none" stroke="#FFE066" stroke-width="1.4" stroke-dasharray="1.4 1"/>
          <circle cx="0" cy="0" r="3.4" fill="#E4572E" stroke="#B23A1C" stroke-width="0.5"/>
          <path transform="scale(0.32)" d="M0,-8 L1.82,-2.51 L7.61,-2.47 L2.94,0.96 L4.70,6.47 L0,3.10 L-4.70,6.47 L-2.94,0.96 L-7.61,-2.47 L-1.82,-2.51 Z" fill="#FFE066"/>
        </g>
      </svg>
    `,

    _heartSvg: (size, style) => `
      <svg class="game-icon stat-icon icon-heart" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; filter:drop-shadow(0 1px 3px rgba(255,107,107,0.45)); ${style}">
        <defs>
          <linearGradient id="heartGradIcons" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#FF6B6B" />
            <stop offset="100%" stop-color="#E81B1B" />
          </linearGradient>
        </defs>
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" 
              fill="url(#heartGradIcons)" fill-opacity="0.95" stroke="#FF4B4B" stroke-width="1.8" stroke-linejoin="round"/>
      </svg>
    `,

    _bankSvg: (size, style) => `
      <svg class="game-icon stat-icon icon-bank" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; filter:drop-shadow(0 1px 3px rgba(79,70,229,0.45)); ${style}">
        <defs>
          <linearGradient id="bankGradIcons" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#A5B4FC" />
            <stop offset="100%" stop-color="#4F46E5" />
          </linearGradient>
        </defs>
        <path d="M3 10 L12 3 L21 10 Z" fill="url(#bankGradIcons)" fill-opacity="0.9" stroke="#6366F1" stroke-width="1.6" stroke-linejoin="round"/>
        <rect x="4" y="19" width="16" height="2" rx="0.5" fill="url(#bankGradIcons)" fill-opacity="0.9" stroke="#6366F1" stroke-width="1.4"/>
        <rect x="6" y="11" width="2.5" height="7" rx="0.5" fill="url(#bankGradIcons)" fill-opacity="0.9" stroke="#6366F1" stroke-width="1.1"/>
        <rect x="11" y="11" width="2.5" height="7" rx="0.5" fill="url(#bankGradIcons)" fill-opacity="0.9" stroke="#6366F1" stroke-width="1.1"/>
        <rect x="16" y="11" width="2.5" height="7" rx="0.5" fill="url(#bankGradIcons)" fill-opacity="0.9" stroke="#6366F1" stroke-width="1.1"/>
      </svg>
    `,

    _waveSvg: (size, style) => `
      <svg class="game-icon stat-icon icon-wave" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; filter:drop-shadow(0 1px 3px rgba(255,61,0,0.4)); ${style}">
        <defs>
          <linearGradient id="swordGradIcons" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#FF8A00" />
            <stop offset="100%" stop-color="#FF1F00" />
          </linearGradient>
        </defs>
        <path d="M7 17 L19 5" stroke="url(#swordGradIcons)" stroke-width="2.2" stroke-linecap="round"/>
        <path d="M7 17 L5 19" stroke="#E2E8F0" stroke-width="2.2" stroke-linecap="round"/>
        <path d="M10 16 L7 13" stroke="#FFD700" stroke-width="1.8" stroke-linecap="round"/>
        <path d="M17 17 L5 5" stroke="url(#swordGradIcons)" stroke-width="2.2" stroke-linecap="round"/>
        <path d="M17 17 L19 19" stroke="#E2E8F0" stroke-width="2.2" stroke-linecap="round"/>
        <path d="M14 16 L17 13" stroke="#FFD700" stroke-width="1.8" stroke-linecap="round"/>
        <path d="M12 9 C14.5 9, 15.5 10.5, 15.5 12.5 C15.5 15, 12 17, 12 17.5 C12 17, 8.5 15, 8.5 12.5 C8.5 10.5, 9.5 9, 12 9 Z" 
              fill="#1E1E2E" fill-opacity="0.9" stroke="#FFD700" stroke-width="1.2" stroke-linejoin="round"/>
      </svg>
    `,

    _roccoSvg: (size, style) => `
      <svg class="game-icon rocco-face-icon" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; display:inline-block; vertical-align:middle; filter:drop-shadow(0 4px 10px rgba(0,0,0,0.5)); ${style}">
        <!-- Ears -->
        <polygon points="15,25 35,15 30,35" fill="#2E2E3E" stroke="#FFD700" stroke-width="1.5"/>
        <polygon points="85,25 65,15 70,35" fill="#2E2E3E" stroke="#FFD700" stroke-width="1.5"/>
        <polygon points="18,24 30,17 27,29" fill="#FF8B8B"/>
        <polygon points="82,24 70,17 73,29" fill="#FF8B8B"/>
        <!-- Face/Head background -->
        <circle cx="50" cy="55" r="38" fill="#3A3A4A" stroke="#FFD700" stroke-width="1.8"/>
        <!-- Raccoon white cheeks -->
        <path d="M15,62 C25,52 35,57 42,67 C45,72 50,77 50,77 C50,77 55,72 58,67 C65,57 75,52 85,62 C75,82 50,85 50,85 C50,85 25,82 15,62 Z" fill="#E2E8F0"/>
        <!-- Raccoon black mask -->
        <path d="M18,45 C28,41 40,45 50,55 C60,45 72,41 82,45 C87,58 77,68 67,63 C57,59 50,61 50,51 C50,61 43,59 33,63 C23,68 13,58 18,45 Z" fill="#1A1A26"/>
        <!-- Nose bridge & Snout -->
        <polygon points="46,53 54,50 50,71" fill="#2E2E3E"/>
        <circle cx="50" cy="71" r="4.5" fill="#111"/>
        <!-- Sunglasses -->
        <rect x="21" y="44" width="24" height="14" rx="4" fill="#111" stroke="#FFD700" stroke-width="1.5"/>
        <rect x="55" y="44" width="24" height="14" rx="4" fill="#111" stroke="#FFD700" stroke-width="1.5"/>
        <line x1="45" y1="49" x2="55" y2="49" stroke="#FFD700" stroke-width="2.5"/>
        <!-- Sunglass reflections -->
        <line x1="24" y1="47" x2="31" y2="47" stroke="#FFF" stroke-width="1.5" stroke-linecap="round"/>
        <line x1="58" y1="47" x2="65" y2="47" stroke="#FFF" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    `,

    _lightningSvg: (size, style) => `
      <svg class="game-icon icon-lightning" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; filter:drop-shadow(0 0 4px #eab308); ${style}">
        <path d="M19 10.5h-5.5L16.5 2 5 13.5h5.5L7.5 22 19 10.5z" fill="#facc15" stroke="#eab308" stroke-width="1.5" stroke-linejoin="round"/>
      </svg>
    `,

    _windSvg: (size, style) => `
      <svg class="game-icon icon-wind" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; filter:drop-shadow(0 0 3px #38bdf8); ${style}">
        <path d="M2 5h14.5c1.9 0 3.5 1.6 3.5 3.5S18.4 12 16.5 12h-2M2 10h11.5c1.4 0 2.5 1.1 2.5 2.5S14.9 15 13.5 15h-1M2 15h16.5c1.9 0 3.5 1.6 3.5 3.5S20.4 22 18.5 22H16" stroke="#38bdf8" stroke-width="2" stroke-linecap="round"/>
      </svg>
    `,

    _xpSvg: (size, style) => `
      <svg class="game-icon icon-xp" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; filter:drop-shadow(0 0 4px rgba(250,204,21,0.6)); ${style}">
        <!-- Single elegant 4-point star matching the in-game style -->
        <path d="M12 2 L14.5 9.5 L22 12 L14.5 14.5 L12 22 L9.5 14.5 L2 12 L9.5 9.5 Z" fill="#ffd93d" stroke="#f59e0b" stroke-width="1.5" stroke-linejoin="round"/>
      </svg>
    `,

    _ticketSvg: (size, style) => `
      <svg class="game-icon icon-ticket" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; filter:drop-shadow(0 1px 3px rgba(168,85,247,0.4)); ${style}">
        <path d="M20 12c-1.1 0-2-.9-2-2V4H6v6c0 1.1-.9 2-2 2s-2 .9-2 2v6h16v-6c0-1.1.9-2 2-2s2-.9 2-2v-2z" fill="none" stroke="#a855f7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <line x1="9" y1="8" x2="15" y2="8" stroke="#cbd5e1" stroke-width="1.5" stroke-linecap="round"/>
        <line x1="9" y1="12" x2="15" y2="12" stroke="#cbd5e1" stroke-width="1.5" stroke-linecap="round"/>
        <line x1="9" y1="16" x2="15" y2="16" stroke="#cbd5e1" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    `,

    _balloonSvg: (size, style) => `
      <svg class="game-icon icon-balloon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; filter:drop-shadow(0 2px 4px rgba(239,68,68,0.35)); ${style}">
        <defs>
          <radialGradient id="balloonGrad" cx="35%" cy="35%" r="65%">
            <stop offset="0%" stop-color="#ff8787" />
            <stop offset="60%" stop-color="#ef4444" />
            <stop offset="100%" stop-color="#991b1b" />
          </radialGradient>
        </defs>
        <circle cx="12" cy="10" r="8" fill="url(#balloonGrad)"/>
        <!-- Tie at bottom -->
        <polygon points="12,18 10,21 14,21" fill="#ef4444"/>
        <!-- String -->
        <path d="M12,21 Q14,23 11,24" stroke="#94a3b8" stroke-width="1" fill="none"/>
      </svg>
    `,

    _unlockedSvg: (size, style) => `
      <svg class="game-icon icon-unlocked" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; ${style}">
        <rect x="3" y="11" width="18" height="11" rx="2" fill="none" stroke="#4ade80" stroke-width="2"/>
        <path d="M7 11V7a5 5 0 0 1 9.9-1" fill="none" stroke="#4ade80" stroke-width="2" stroke-linecap="round"/>
        <circle cx="12" cy="16" r="1.5" fill="#4ade80"/>
      </svg>
    `,

    _lockedSvg: (size, style) => `
      <svg class="game-icon icon-locked" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; ${style}">
        <rect x="3" y="11" width="18" height="11" rx="2" fill="none" stroke="#f87171" stroke-width="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4" fill="none" stroke="#f87171" stroke-width="2"/>
        <circle cx="12" cy="16" r="1.5" fill="#f87171"/>
      </svg>
    `,

    _idleSvg: (size, style) => `
      <svg class="game-icon icon-idle" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; ${style}">
        <path d="M5 19h14M11 5l-6 10h12" stroke="#60a5fa" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 4h3l-3 4h3" stroke="#60a5fa" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    `,

    _checkedSvg: (size, style) => `
      <svg class="game-icon icon-checked" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; ${style}">
        <circle cx="12" cy="12" r="10" fill="none" stroke="#4ade80" stroke-width="2"/>
        <path d="M8 12l3 3 5-5" stroke="#4ade80" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `,

    _warningSvg: (size, style) => `
      <svg class="game-icon icon-warning" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; ${style}">
        <path d="M12 2L2 22h20L12 2z" fill="none" stroke="#facc15" stroke-width="2" stroke-linejoin="round"/>
        <line x1="12" y1="9" x2="12" y2="14" stroke="#facc15" stroke-width="2" stroke-linecap="round"/>
        <circle cx="12" cy="18" r="1" fill="#facc15"/>
      </svg>
    `,

    _shieldSvg: (size, style) => `
      <svg class="game-icon icon-shield" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:${size}px; height:${size}px; vertical-align:middle; display:inline-block; filter:drop-shadow(0 0 4px #ffd700); ${style}">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="rgba(255,215,0,0.25)" stroke="#ffd700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 6v12M8 10h8" stroke="#ffe066" stroke-width="2" stroke-linecap="round"/>
      </svg>
    `,

    // Helper mappings to pre-baked PNG sprites for Category 1 & Category 3
    _png: (src, size, style) => `
      <img src="${src}" class="game-icon" style="width:${size}px; height:${size}px; object-fit:contain; vertical-align:middle; display:inline-block; ${style}">
    `,

    // The single, centralized retrieval helper
    get(key, size = 16, extraStyle = '') {
      const lower = key.toLowerCase().trim();

      // Category 1: Difficulty Indicators & Filters
      if (lower === 'easy' || lower === '🟢') {
        return this._png('sprites/ui/icons/easy.png', size, extraStyle);
      }
      if (lower === 'medium' || lower === '🔵') {
        return this._png('sprites/ui/icons/medium.png', size, extraStyle);
      }
      if (lower === 'hard' || lower === '🟠' || lower === '🟡') {
        return this._png('sprites/ui/icons/hard.png', size, extraStyle);
      }
      if (lower === 'expert' || lower === '🔴') {
        return this._png('sprites/ui/icons/expert.png', size, extraStyle);
      }
      if (lower === 'master' || lower === '🟣') {
        return this._png('sprites/ui/icons/master.png', size, extraStyle);
      }

      // Category 2: Economy & Rocco
      if (lower === 'dollars' || lower === 'dollar' || lower === 'cash' || lower === '💵' || lower === '💰') {
        return this._png('sprites/ui/icons/coin.png', size, extraStyle);
      }
      if (lower === 'permits' || lower === 'permit' || lower === '📄') {
        return this._permitsSvg(size, extraStyle);
      }
      if (lower === 'tickets' || lower === 'ticket' || lower === '🎟') {
        return this._ticketSvg(size, extraStyle);
      }
      if (lower === 'bank' || lower === '🏦') {
        return this._bankSvg(size, extraStyle);
      }
      if (lower === 'rocco' || lower === 'raccoon' || lower === '🦝' || lower === '🦝🕶️' || lower === '🕶️') {
        return this._roccoSvg(size, extraStyle);
      }

      // Category 3: Stats, Guide & Navigation
      if (lower === 'guide' || lower === 'book' || lower === '📖') {
        return this._png('sprites/ui/icons/level_library.png', size, extraStyle);
      }
      if (lower === 'balloon' || lower === 'balloons' || lower === '🎈') {
        return this._balloonSvg(size, extraStyle);
      }
      if (lower === 'tools' || lower === 'upgrade' || lower === '🛠️') {
        return this._png('sprites/ui/icons/upgrade.png', size, extraStyle);
      }
      if (lower === 'music' || lower === 'notes' || lower === '🎵' || lower === '🎶' || lower === '📻') {
        return this._png('sprites/ui/icons/ability.png', size, extraStyle);
      }
      if (lower === 'trophy' || lower === 'leaderboard' || lower === '🏆') {
        return this._png('sprites/ui/icons/leader_board.png', size, extraStyle);
      }
      if (lower === 'medal' || lower === 'achievement' || lower === '🎖️' || lower === '🏅') {
        return this._png('sprites/ui/icons/all_rounder.png', size, extraStyle);
      }
      if (lower === 'profile' || lower === 'user' || lower === '👤') {
        return this._png('sprites/ui/icons/profile_login.png', size, extraStyle);
      }
      if (lower === 'map' || lower === '🗺️' || lower === '🗺') {
        return this._png('sprites/ui/icons/map.png', size, extraStyle);
      }
      if (lower === 'wave' || lower === 'combat' || lower === '🌊') {
        return this._waveSvg(size, extraStyle);
      }
      if (lower === 'xp' || lower === 'stars' || lower === 'star' || lower === '✨' || lower === '⭐') {
        return this._xpSvg(size, extraStyle);
      }
      if (lower === 'gamepad' || lower === 'controller' || lower === '🎮') {
        return this._png('sprites/ui/icons/campaign_mode.png', size, extraStyle);
      }
      if (lower === 'restart_level' || lower === 'random' || lower === '🎲') {
        return this._png('sprites/ui/icons/restart_level.png', size, extraStyle);
      }

      // Category 4: Power-Ups & Spells
      if (lower === 'lightning' || lower === 'strike' || lower === '⚡') {
        return this._lightningSvg(size, extraStyle);
      }
      if (lower === 'wind' || lower === 'gust' || lower === '🌪️' || lower === '🌪') {
        return this._windSvg(size, extraStyle);
      }
      if (lower === 'lives' || lower === 'heart' || lower === '❤️' || lower === '❤') {
        return this._heartSvg(size, extraStyle);
      }
      if (lower === 'shield' || lower === 'armor' || lower === '🛡️' || lower === '🛡') {
        return this._shieldSvg(size, extraStyle);
      }

      // Additional helpful symbols
      if (lower === 'unlocked' || lower === '🔓') {
        return this._unlockedSvg(size, extraStyle);
      }
      if (lower === 'locked' || lower === '🔒') {
        return this._lockedSvg(size, extraStyle);
      }
      if (lower === 'idle' || lower === '💤') {
        return this._idleSvg(size, extraStyle);
      }
      if (lower === 'checked' || lower === '✓' || lower === 'check') {
        return this._checkedSvg(size, extraStyle);
      }
      if (lower === 'warning' || lower === '⚠️' || lower === '⚠') {
        return this._warningSvg(size, extraStyle);
      }

      // Fallback
      return key;
    },

    // Automatic hydration helper for [data-icon] elements in the DOM
    hydrate(root = document) {
      if (!root || typeof root.querySelectorAll !== 'function') return;
      const els = root.querySelectorAll('[data-icon]');
      els.forEach(el => {
        const iconKey = el.getAttribute('data-icon');
        if (!iconKey) return;
        const size = parseInt(el.getAttribute('data-icon-size') || '16', 10);
        const placement = el.getAttribute('data-icon-placement') || 'prepend';
        const style = el.getAttribute('style') || '';
        const iconHtml = this.get(iconKey, size, style);
        if (placement === 'replace') {
          el.innerHTML = iconHtml;
        } else if (placement === 'append') {
          el.innerHTML += iconHtml;
        } else {
          el.innerHTML = iconHtml + el.innerHTML;
        }
        el.removeAttribute('data-icon');
      });
    }
  };

  // Export to global scope
  window.GameIcons = GameIcons;

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => GameIcons.hydrate());
    } else {
      GameIcons.hydrate();
    }
  }
})();
